const QUOTES = [
  {
    name: "Eleanor M.",
    role: "Bride · September wedding",
    quote:
      "Melissa made me feel like the most polished version of myself — not someone else. Every photo I have, I love.",
  },
  {
    name: "Priya R.",
    role: "Editor at LUME Magazine",
    quote:
      "Working with Melissa on our spring shoot was effortless. She has the rarest gift: restraint.",
  },
  {
    name: "Cassidy & James",
    role: "Engagement · Charleston",
    quote:
      "She arrived calmly, prepped my skin like a facialist, and I genuinely looked like myself on the best day of my life.",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 md:py-36 bg-melissa-bg2">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <p className="text-xs uppercase tracking-overline text-melissa-rose mb-6">
          04 — Kind Words
        </p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-melissa-ink leading-tight tracking-tight max-w-3xl">
          The most generous part of this work is the <em className="italic text-melissa-rose">people.</em>
        </h2>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {QUOTES.map((q, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-melissa-bg border border-melissa-border p-8 md:p-10 flex flex-col"
            >
              <span className="font-serif text-5xl text-melissa-rose leading-none mb-4">“</span>
              <blockquote className="font-serif text-xl md:text-2xl text-melissa-ink leading-snug flex-1">
                {q.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-melissa-border">
                <div className="font-serif text-lg text-melissa-ink">{q.name}</div>
                <div className="text-[10px] uppercase tracking-overline text-melissa-inkSoft mt-1">
                  {q.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
